import React, { useState } from 'react';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TR from './../../Trans';

function LogoutFeedbackDialog(props) {

  return (
    <BDialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {TR.cm_new_app_feedback_question}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onNo}>{TR.cm_no}</Button>
          <Button color="success" onClick={props.onYes}>{TR.cm_yes}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default LogoutFeedbackDialog;